import { UPLOAD_SOURCES } from '@cld/upload-widget';

const defaultSources = [
  UPLOAD_SOURCES.LOCAL,
  UPLOAD_SOURCES.URL,
  UPLOAD_SOURCES.CAMERA,
  UPLOAD_SOURCES.IMAGE_SEARCH,
  UPLOAD_SOURCES.GOOGLE_DRIVE,
  UPLOAD_SOURCES.DROPBOX,
  UPLOAD_SOURCES.FACEBOOK,
  UPLOAD_SOURCES.INSTAGRAM,
  UPLOAD_SOURCES.SHUTTERSTOCK,
  UPLOAD_SOURCES.GETTY,
  UPLOAD_SOURCES.ISTOCK,
  UPLOAD_SOURCES.UNSPLASH,
];

export const getAllSources = () => defaultSources.slice();

export default {
  cloudName: null,
  uploadPreset: '',
  uploadPrefix: '',
  secure: true,
  folder: null,
  maxFiles: null,
  cropping: null,
  inlineMode: false,
  sources: getAllSources(),
  defaultSource: null, // intentionally set to null
  multiple: true,
  googleApiKey: null,
  dropboxAppKey: null,
  facebookAppId: null,
  instagramServer: null,
  shutterstockServer: null,
  istockServer: null,
  gettyServer: null,
  searchBySites: false,
  searchByRights: false,
  publicId: '',
  autoMinimize: false,
  requirePrepareParams: false,
  useTagsCallback: false,
  useUploadPresetsCallback: false,
  useMetadataCallback: false,
  text: null,
  language: 'en',
  showAdvancedOptions: false,
  showPoweredBy: true,
  showCompletedButton: false,
  showInsecurePreview: false,
  styles: null,
  croppingShowBackButton: true,
  croppingCoordinatesMode: 'custom',
  croppingDefaultSelectionRatio: 1,
  croppingShowDimensions: false,
  theme: null,
  tabInsideWidget: true,
};
